<template>
  <div class="inquire">
    <Title />
    <div class="inquireTittle">
      <!--案件查询--头 -->
      <h5>案件查询</h5>
      <!-- 所有案件 -->
      <div class="allCase">
        <!-- 单个案件--头 -->

        <div class="Case" v-for="(item, index) in list" :key="index">
          <div class="Num">
            <span>案件号：</span>
            <p>{{ item.case_no }}</p>
          </div>
          <div class="state">
            <span>状态：</span>
            <p>{{ item.case_status_name }} </p>
          </div>
          <div class="principal">
            <span>案件委托人：</span>
            <p>{{ item.name }}</p>
          </div>
          <div class="idCard">
            <span>身份证号：</span>
            <p>{{ item.id_number }}</p>
          </div>
          <div class="applicationTime">
            <span>申请时间：</span>
            <p>{{ item.start_time }}</p>
          </div>
          <div class="completionTime">
            <span>完成时间：</span>
            <p> {{ item.case_status_name == "已完成" ? item.end_time : "-" }} </p>
          </div>
          <div class="details" @click="details">
            <span></span>
            <p>查看案件详情</p>
          </div>
          <!-- 查看弹窗 -->
          <van-dialog v-model="show">
            <div class="logobox">
              <img class="logo" src="../assets/img/home/logo.png" alt="">
            </div>
            <van-divider :style="{ color: '#0b87f2', borderColor: '#e50012', padding: '0 16px' }">
              案件详情
            </van-divider>
            <div class="info">
              <div>
                姓名：
              </div>
              <div>{{ item.name }}</div>
            </div>
            <div class="info">
              <div>性别：</div>
              <div>{{ item.sex == 0 ? "女" : " 男" }}</div>
            </div>
            <div class="info">
              <div> 身份证号码：</div>
              <div>
                {{ item.id_number }}
              </div>
            </div>
            <div class="info">
              <div>受理调解中心：</div>
              <div> {{ item.mediation_center }}</div>
            </div>
            <div class="info">
              <div> 省份：</div>
              <div>
                {{ item.province }}
              </div>
            </div>
            <div class="info">
              <div> 受理时间：</div>
              <div>
                {{ item.start_time }}
              </div>
            </div>
            <div class="info">
              <div> 专属调解员：</div>
              <div>
                {{ item.mediator_name ? item.mediator_name : "暂无" }}
              </div>
            </div>
            <div class="info">
              <div>
                案件状态：
              </div>
              <div>
                {{ item.case_status_name }}
              </div>
            </div>
            <!-- <div class="info">
              <div>咨询电话：</div>
              <div>
                {{ item.tel }}
              </div>
            </div> -->
          </van-dialog>
        </div>

        <!-- 单个案件--尾 -->
      </div>
    </div>
    <!-- 底部版权信息 -->
    <copyright />
  </div>
</template>

<script>
import Title from "../components/title.vue";
import copyright from "../components/copyright.vue";
import axios from "axios";
import { Dialog } from 'vant';
export default {
  components: {
    Title,
    copyright,
    [Dialog.Component.name]: Dialog.Component,
  },
  mounted() {
    this.getlist({
      id_number: this.$route.params.id,
      mobile: this.$route.params.telephone,
      code: this.$route.params.sms
    })

  },
  data() {
    return {
      list: [],
      show: false,
      username: '',
      password: '',
    }
  },
  methods: {
    async getlist(param) {
      let res = await axios.post('/api/case_search/search', param)
      if (res.data.code == -1) {
        this.$router.push({ path: "/CaseInquiry" })
      }
      this.list = res.data.data.case_list
      console.log(res.data.data.case_list);
    },
    details() {
      this.show = true;
    },
    onSubmit(values) {
      console.log('submit', values);
    },
  }
};
</script>

<style scoped>
.info {
  font-size: 12px;
  /* text-align: left; */
  margin: 10px 30px;
  display: flex;
}

.info :nth-child(1) {
  width: 36%;
  text-align: right;
}

.logobox {
  display: flex;
  justify-content: center;
}

.logo {
  width: 88px;
  height: 88px;

}

.infoTitle {
  text-align: center;
}

.inquireTittle {
  width: 100%;
  height: auto;
  padding-top: 3.125rem;
}

.inquireTittle h5 {
  font-size: 1rem;
  font-weight: 500;
  color: #27292b;
  text-align: center;
}

.allCase {
  margin: 0.75rem auto;
  width: 21.9375rem;
}

.Case {
  height: 10.9375rem;
  position: relative;
  border-radius: 8px;
  opacity: 1;
  background: #ffffff;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
  font-size: 0.875rem;
  padding: 0.625rem 0.625rem;
  margin-bottom: 1rem;
}

.Case div {
  margin-bottom: 0.3125rem;
}

.Case p {
  display: inline-block;
}

.state p {
  color: red;
}

.details {
  position: absolute;
  right: 3%;
  top: 30%;
}

.details span {
  display: block;
  width: 2.5625rem;
  height: 2.5625rem;
  background: url(../assets/img/base/inquire-icon.svg) no-repeat center center;
  margin: 0 auto;
  margin-bottom: 0.1875rem;
}

.details p {
  font-size: 0.875rem;
  font-weight: 400;
  color: #27292b;
}
</style>


// WEBPACK FOOTER //
// src/page/inquire.vue